import React, { useState } from 'react';

const DoctorCardNoSchedule = ({ doctor, index, onUpdate }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editedDoctor, setEditedDoctor] = useState({ ...doctor });

  const handleSave = () => {
    onUpdate(index, editedDoctor);
    setIsEditing(false);
  };

  const handleCancel = () => {
    setEditedDoctor({ ...doctor });
    setIsEditing(false);
  };

  const handleFieldChange = (key, value) => {
    setEditedDoctor((prev) => ({ ...prev, [key]: value }));
  };

  return (
    <div className="bg-white border border-gray-200 rounded-lg p-6 hover:shadow-md transition-shadow">
      <div className="flex justify-between items-start mb-4">
        <h3 className="text-lg font-semibold text-gray-900">
          {editedDoctor.primary_name || `Doctor ${index + 1}`}
        </h3>
        {!isEditing ? (
          <button
            onClick={() => setIsEditing(true)}
            className="text-blue-600 hover:text-blue-700 text-sm font-medium"
          >
            Edit
          </button>
        ) : (
          <div className="flex gap-2">
            <button
              onClick={handleSave}
              className="text-green-600 hover:text-green-700 text-sm font-medium"
            >
              Save
            </button>
            <button
              onClick={handleCancel}
              className="text-gray-600 hover:text-gray-700 text-sm font-medium"
            >
              Cancel
            </button>
          </div>
        )}
      </div>

      <div className="space-y-2 text-sm">
        <div>
          <span className="font-medium text-gray-600">Name:</span>{' '}
          {isEditing ? (
            <input
              type="text"
              value={editedDoctor.primary_name || ''}
              onChange={(e) => handleFieldChange('primary_name', e.target.value)}
              className="ml-2 px-2 py-1 border border-gray-300 rounded w-48"
            />
          ) : (
            <span className="text-gray-900">{editedDoctor.primary_name || 'N/A'}</span>
          )}
        </div>
        <div>
          <span className="font-medium text-gray-600">Speciality:</span>{' '}
          {isEditing ? (
            <input
              type="text"
              value={editedDoctor.speciality || ''}
              onChange={(e) => handleFieldChange('speciality', e.target.value)}
              className="ml-2 px-2 py-1 border border-gray-300 rounded w-48"
            />
          ) : (
            <span className="text-gray-900">{editedDoctor.speciality || 'N/A'}</span>
          )}
        </div>
        <div>
          <span className="font-medium text-gray-600">Gender:</span>{' '}
          {isEditing ? (
            <select
              value={editedDoctor.gender || ''}
              onChange={(e) => handleFieldChange('gender', e.target.value || null)}
              className="ml-2 px-2 py-1 border border-gray-300 rounded"
            >
              <option value="">Not specified</option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
            </select>
          ) : (
            <span className="text-gray-900">{editedDoctor.gender || 'N/A'}</span>
          )}
        </div>
        <div>
          <span className="font-medium text-gray-600">Services:</span>
          {isEditing ? (
            <textarea
              value={editedDoctor.service_provided || ''}
              onChange={(e) => handleFieldChange('service_provided', e.target.value)}
              className="ml-2 w-full px-2 py-1 border border-gray-300 rounded mt-1"
              rows={2}
            />
          ) : (
            <p className="text-gray-900 mt-1">{editedDoctor.service_provided || 'N/A'}</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default DoctorCardNoSchedule;
